export default function blankCells(w, h) {
	const cells = [];
	for (let y = 0; y < h * 2; ++y) {
		const row = [];
		cells.push(row);
		for (let x = 0; x < w * 2; ++x)
			row.push({
				x, y,
				xParity: !!(x & 1),
				yParity: !!(y & 1),
				xyParity: (x & 1) == (y & 1),
				vWall: false, hWall: false
			});
	}
	return cells;
}
